import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Portal from "./pages/Portal";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import AdminUsers from "./pages/admin/AdminUsers";
import Suppliers from "./pages/Suppliers";
import Products from "./pages/Products";
import Projects from "./pages/Projects";
import PurchaseRequests from "./pages/PurchaseRequests";
import RFQs from "./pages/RFQs";
import QuotationComparison from "./pages/QuotationComparison";
import PurchaseOrders from "./pages/PurchaseOrders";
import PurchaseOrderDetail from "./pages/PurchaseOrderDetail";
import GoodsReceipts from "./pages/GoodsReceipts";
import Invoices from "./pages/Invoices";
import InvoiceDetail from "./pages/InvoiceDetail";
import Stock from "./pages/Stock";
import RecycleBin from "./pages/RecycleBin";

function P({ children }) {
    return <ProtectedRoute>{children}</ProtectedRoute>;
}

function PPurchasing({ children }) {
    return <ProtectedRoute module="purchasing">{children}</ProtectedRoute>;
}

// Purchasing module + block requester (they only get PR screens)
function POps({ children }) {
    return <ProtectedRoute module="purchasing" blockRoles={["requester"]}>{children}</ProtectedRoute>;
}

// Page-level role allow-lists (must mirror Sidebar `roles` and backend read guards)
const ALL_PURCH = ["admin", "purchasing_manager", "purchasing_specialist",
                   "warehouse", "finance",
                   "project_manager", "general_manager", "auditor"];
const PURCH_TEAM = ["admin", "purchasing_manager", "purchasing_specialist"];
const PAGES = {
    dashboard: ALL_PURCH,
    pr: [...ALL_PURCH, "requester"],
    rfq: [...PURCH_TEAM, "general_manager", "auditor"],
    po: [...PURCH_TEAM, "general_manager", "finance", "auditor"],
    // Eyes Çelik: Müdür Mal Kabul'da YOK
    gr: ["admin", "warehouse", "purchasing_specialist", "auditor"],
    // Eyes Çelik: Müdür Fatura'da YOK
    invoice: ["admin", "finance", "purchasing_specialist", "auditor"],
    stock: ["admin", "warehouse", "purchasing_manager", "purchasing_specialist", "auditor"],
    suppliers: [...PURCH_TEAM, "auditor"],
    products: [...PURCH_TEAM, "warehouse", "auditor"],
    projects: [...PURCH_TEAM, "project_manager", "general_manager", "auditor"],
};

function Guarded({ allow, children }) {
    return <ProtectedRoute module="purchasing" allowRoles={allow}>{children}</ProtectedRoute>;
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/portal" element={<P><Portal /></P>} />
                    <Route path="/profile" element={<P><Profile /></P>} />
                    <Route path="/admin/users" element={<ProtectedRoute allowRoles={["admin"]}><AdminUsers /></ProtectedRoute>} />
                    <Route path="/" element={<Guarded allow={PAGES.dashboard}><Dashboard /></Guarded>} />
                    <Route path="/suppliers" element={<Guarded allow={PAGES.suppliers}><Suppliers /></Guarded>} />
                    <Route path="/products" element={<Guarded allow={PAGES.products}><Products /></Guarded>} />
                    <Route path="/projects" element={<Guarded allow={PAGES.projects}><Projects /></Guarded>} />
                    <Route path="/purchase-requests" element={<Guarded allow={PAGES.pr}><PurchaseRequests /></Guarded>} />
                    <Route path="/rfqs" element={<Guarded allow={PAGES.rfq}><RFQs /></Guarded>} />
                    <Route path="/rfqs/:id" element={<Guarded allow={PAGES.rfq}><QuotationComparison /></Guarded>} />
                    <Route path="/purchase-orders" element={<Guarded allow={PAGES.po}><PurchaseOrders /></Guarded>} />
                    <Route path="/purchase-orders/:id" element={<Guarded allow={PAGES.po}><PurchaseOrderDetail /></Guarded>} />
                    <Route path="/goods-receipts" element={<Guarded allow={PAGES.gr}><GoodsReceipts /></Guarded>} />
                    <Route path="/invoices" element={<Guarded allow={PAGES.invoice}><Invoices /></Guarded>} />
                    <Route path="/invoices/:id" element={<Guarded allow={PAGES.invoice}><InvoiceDetail /></Guarded>} />
                    <Route path="/stock" element={<Guarded allow={PAGES.stock}><Stock /></Guarded>} />
                    <Route path="/recycle-bin" element={<ProtectedRoute module="purchasing" allowRoles={["admin","purchasing_manager","finance","auditor"]}><RecycleBin /></ProtectedRoute>} />
                    <Route path="*" element={<Navigate to="/portal" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
